import React from 'react'

const CommentSectionPropper = (props) => {
  const {showCommentSection, commentaireLoader, commentaires} = props

  // Conversion de la date en format 00/00/0000 à 00:00
  const transformDate = (date) => {
    const dateformat = new Date(date)

    const formattedDate = dateformat.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    const formattedTime = dateformat.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Paris',
    })

    return (
      <span className={'d-flex gap-1'}>
        <div className={'fw-600'}>{formattedDate}</div>à
        <div className={'text-muted'}>{formattedTime}</div>
      </span>
    )
  }

  return (
    <>
      {showCommentSection && (
        <>
          <hr className={'text-muted w-100 my-1'} />

          <div
            className={`w-400px overflow-y-auto max-h-300px min-h-70px d-flex flex-column gap-3 mt-2
                ${commentaireLoader && 'align-items-center justify-content-center'}
                ${commentaires.length == 0 && 'justify-content-center'}
                `}
          >
            {commentaireLoader ? (
              <span className='spinner-border spinner-border-sm align-middle w-20px h-20px'></span>
            ) : (
              <>
                {commentaires.length > 0 ? (
                  commentaires.map((commentaire: any, index: number) => {
                    return (
                      <>
                        <div className={'d-flex flex-column w-100 gap-1 px-3'}>
                          <div className={'d-flex justify-content-between'}>
                            <div className={'fw-semibold'}>
                              {commentaire.author.prenom} {commentaire.author.nom}
                            </div>
                            <div>{transformDate(commentaire?.createdAt)}</div>
                          </div>
                          <span
                            className={'border border-muted p-3 p-3 text-start'}
                            style={{
                              borderRadius: '0 5px 5px 5px',
                            }}
                          >
                            {commentaire.message}
                          </span>
                        </div>
                      </>
                    )
                  })
                ) : (
                  <span className={'text-center'}>Aucun commentaire ajouté sur cette pièce</span>
                )}
              </>
            )}
          </div>
        </>
      )}
    </>
  )
}

export default CommentSectionPropper